<template>
  <div class="mb-20 lg:mb-[160px]">
    <AboutUsOurTotality />
    <AboutUsFeatures class="mt-[80px] lg:mt-[120px]" />
    <AboutUsFounders class="mt-[80px] lg:mt-[120px]" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { renderHead } from '@helper/head/head-home'
import AboutUsOurTotality from '@/components/pages/about-us/our-totality'
import AboutUsFeatures from '@/components/pages/about-us/features'
import AboutUsFounders from '@/components/pages/about-us/founders'

export default {
  name: 'PageAboutUs',
  components: { AboutUsFounders, AboutUsFeatures, AboutUsOurTotality },
  auth: false,
  layout: 'main',
  async asyncData ({ store }) {
    await store.dispatch('local/asyncDataAboutUs')
  },
  head () {
    return renderHead({ meta: this.getMeta })
  },
  computed: {
    ...mapGetters('global', ['getMeta'])
  }
}
</script>

<style scoped>

</style>
